export default class Appointment {
    constructor() {
        this.init();
    }

    checkbox = document.getElementById(
        'is-comment-required',
    ) as HTMLInputElement | null;

    init() {
        Appointment.initCheckedCheckbox();
        Appointment.initJoinFile();
    }

    static initCheckedCheckbox() {
        Appointment.actionCheckboxes();
        const checkboxes = jQuery('input[type="checkbox"]');
        checkboxes.on('change', () => {
            Appointment.actionCheckboxes();
        });
    }

    static initJoinFile() {
        $('#file').on('change', () => {
            const input = document.getElementById('file');
            const fileName = input.files.length > 0 ? input.files[0].name : '';
            document.getElementById('file-name').textContent = fileName;
        });
    }

    static actionCheckboxes() {
        const max = 2;
        if ($('input[class=form-selectgroup-input]:checked').length >= max) {
            $('input[class=form-selectgroup-input]').attr('disabled', 'disabled');
            $('input[class=form-selectgroup-input]:checked').removeAttr('disabled');
        } else {
            $('input[class=form-selectgroup-input]').removeAttr('disabled');
        }
        let nb = 0;
        document.querySelectorAll('.form-selectgroup-input').forEach((checkbox) => {
            if (checkbox.getAttribute('data-comment') == 1 && checkbox.checked) {
                nb += 1;
            }
            if (nb >= 1) {
                document.querySelector('#exampleFormControlTextarea1').required = true;
                document.getElementById('required-comment').style.display = 'none';
            } else {
                document.querySelector('#exampleFormControlTextarea1').required = false;
                document.getElementById('required-comment').style.display = 'block';
            }
        });
    }

    static actionListener() {
        /* display / hide actions button */
        window.addEventListener('scroll', () => {
            if (document.getElementById('home-testimonials') != null) {
                const testimonials = document.getElementById('home-testimonials');
                if (testimonials) {
                    const positionSection = testimonials.getBoundingClientRect();
                    const height = positionSection.height * -1;
                    const actions = document.querySelector('#actions');

                    if (actions) {
                        if ((positionSection.top < 1 && positionSection.top > height)
                            || (positionSection.top < 1 && positionSection.top < height)) {
                            actions.classList.add('d-none');
                            actions.classList.remove('d-flex');
                        } else if (positionSection.top < height || positionSection.top > 1) {
                            actions.classList.add('d-flex');
                            actions.classList.remove('d-none');
                        }
                    }
                }
            }
        });
    }

    static displaySubMenu() {
        const menu = document.querySelector('ul.dropdown-menu');
        if (menu) {
            menu.classList.add('show');
        }

        const firstLink = document.querySelector('#dropdownMenuLink');
        if (firstLink) {
            firstLink.classList.add('show');
        }
    }
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
    (() => new Appointment())();
});
